import apiInstance from "./index";

/**
 * The AP queue (afms-api P3, api/ap-queue): pickup invoices this org has
 * received, by where they stand, limited to the locations the caller
 * processes. -> { data: [row], summary: { withAp|readyToSend|waitingApproval|
 * returned|paid: { count, amount } }, limitedToLocations }
 * row: { id, number, vendorName, amount, pickupNumber, siteName, locationId,
 *   streamName, state, approvalState, approvalInstanceId, receivedAt,
 *   sentToApAt, daysWithAp, paidOn, paidBy, paymentReference }
 * 403 { error } for someone with no AP role.
 */
export const ApQueueApiService = {
  list: ({ state, paidDays } = {}) =>
    apiInstance.get("/ap-queue", { params: { state: state || undefined, paidDays: paidDays || undefined } }),
  // Whether the caller processes any payables: { allowed, limitedToLocations }.
  // The sidebar shows the AP queue only when allowed.
  access: () => apiInstance.get("/ap-queue/access"),
};

export default ApQueueApiService;
